import React from 'react'
import { useRevealProps } from '../../MwPage/components/Reveal'
import { Section } from '../../MwPage/styled'
import { videoTestimonials } from '../../content'
import { useFocus } from '../focus'
import { Column, Wrap } from '../styled'
import { VideoCard, Videos, VideosTitle } from './TestimonialsSection'

/**
 * "Hear directly from entrepreneurs": the member video stories on their own, under the press strip, as the
 * trial pages place them.
 *
 * @param onPlay  called with a member's video to open the lightbox
 */
const MemberVideosSection = ({ onPlay }) => {
  const { memberVideos, testimonials } = useFocus()
  const videos = memberVideos.slugs
    .map((slug) => videoTestimonials.find((video) => video.slug === slug))
    .filter(Boolean)

  return (
    <Section $ice style={{ padding: 'clamp(28px, 3.5vw, 40px) 24px' }}>
      <Wrap>
        <Column $max={820} {...useRevealProps()}>
          <div>
            <VideosTitle>{memberVideos.title}</VideosTitle>
            <Videos>
              {videos.map((video) => (
                <VideoCard
                  key={video.slug}
                  video={video}
                  playLabel={testimonials.playLabel(video.name)}
                  onPlay={onPlay}
                />
              ))}
            </Videos>
          </div>
        </Column>
      </Wrap>
    </Section>
  )
}

export default MemberVideosSection
